export const environment = {
  production: true, 
  url: `https://dev.deluxy.it/api`, // redirected to => https://dev.deluxy.it:3001
  siteUrl: `https://dev.deluxy.it`,
  publicKey: 'BBuVKEMd15f0vd75V5xIISjGndJMpPynYmz1o_KkGgV5igbdUCgErV35X-UQShW6RFAtI98CwMOyBfiP2FUj8kg',
  privateKey: 'drJf2RNrtv072ssF9tNPHXKKEtgJThxS8fgGNYWgI1U',
  // qontoClientId: 'deluxy-srl-8122',
  qontoClientId: '2032f595-3609-4d85-a17c-418e02551b25',
  qontoRedirectUrl: 'https://dev.deluxy.it/qontoCallback',
  qontoResponseType: 'code',
  qontoScope: 'offline_access organization.read%20payment.write',
  qontoState: 'fbade0eff55e2540f4b00ffc347702cda6102578813c0dde42675baad7d89a54',
  server: 'DEVELOPMENT',
  stripePublishableKey: 'pk_test_51S0KucPle1MW1pVpaPFureZSNpA0pIOAUx0yiic4b0dhjflSPWw3ejFnLsLNxxu3QrxtOXWGYPLoevRGVkfOpil3007Ts46TAY',
};

// build for dev:  ng build --configuration=dev 